<nz-table #tabela class="table-custom-border-none" nzSize="small" [nzData]="dataSet?.content" [nzShowPagination]="true"
  [nzFrontPagination]="false" [nzShowTotal]="rangeTemplate" [nzNoResult]="empty" nzShowSizeChanger
  [nzLoading]="loadingTabela" [nzTotal]="dataSet?.totalElements" [(nzPageIndex)]="pageIndex" [(nzPageSize)]="pageSize"
  (nzPageIndexChange)="buscarDados()" (nzPageSizeChange)="buscarDados(true)" [nzScroll]="isSmallScreen ? { x: '100vw' } : {} ">
  <!--[nzScroll]="{ x: '100vw' }"-->
  <thead>
    <tr class="table-theme-bg-color thead-primary-color">
      <th *ngFor="let coluna of colunas">
        {{ coluna }}
      </th>
    </tr>
  </thead>
  <tbody class="bg-section">
    <tr *ngFor="let data of dataSet?.content">
      <td *ngFor="let key of columnKeys">
        <ng-container *ngIf="!isObject(data[key]); else objectValue">
          <ng-container *ngIf="isBoolean(data[key]); else notBoolean">
            <div *ngIf="data[key]">Ativo</div>
            <div *ngIf="!data[key]">Inativo</div>
          </ng-container>
          <ng-template #notBoolean>
            <div *ngIf="isDataCadastro(data[key], key)">
              {{ data[key] | date: 'dd/MM/yyyy' }}
            </div>
            <div *ngIf="!isDataCadastro(data[key], key)" class="limitText">
              <ng-container *ngIf="key === 'numeroCena'">
                {{ data['numeroCena'] + data['complementoCena'] }}
              </ng-container>
              <ng-container *ngIf="key !== 'numeroCena'">
                {{ data[key] }}
              </ng-container>
            </div>
          </ng-template>
        </ng-container>
        <ng-template #objectValue>
          <div [ngSwitch]="key" class="limitText">
            <ng-container *ngSwitchCase="'status'">
              <div *ngIf="data[key]?.descricao" class="fw-bold" [ngClass]="colorFn(data[key].descricao)">
                {{ data[key].descricao }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'equipe'">
              <div *ngIf="data[key]?.equipeNome">
                {{ data[key].equipeNome }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'capitulo'">
              <div *ngIf="data[key]?.numeroCapitulo">
                {{ data[key].numeroCapitulo }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'cenario'">
              <div *ngIf="data[key]?.descricao">
                {{ data[key].descricao }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'frente'">
              <div *ngIf="data[key]?.frenteDesc">
                {{ data[key].frenteDesc }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'roteiro'">
              <div *ngIf="data[key]?.numeroRoteiro">
                {{ data[key].numeroRoteiro }}
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div *ngIf="data[key]?.descricao">
                {{ data[key].descricao }}
              </div>
              <div *ngIf="data[key]?.nome">
                {{ data[key].nome }}
              </div>
            </ng-container>
          </div>
        </ng-template>
      </td>
      <td>
        <ng-template [ngxPermissionsOnly]="[permissaoEnum.Editar, perfilEnum.Administracao]">

          <ng-container *ngIf="nomeItem === 'roteiro';else default">
            <button nz-button nzType="text" nzSize="small" nz-popover
              [nzPopoverContent]="data.edit ? 'Editar' : 'Não permitido editar'" nzPopoverPlacement="topRight"
              (click)="edit(data.id)" [disabled]="!data.edit">
              <span *ngIf="data.edit" class="fs-4 mx-2 tabler--edit"></span>
              <span *ngIf="!data.edit" class="fs-4 mx-2 tabler--edit text-secondary"></span>
            </button>
          </ng-container>

          <ng-template #default>
            <ng-container *ngIf="!esconderEditar">
              <button nz-button nzType="text" nzSize="small" nz-popover nzPopoverContent="Editar"
                nzPopoverPlacement="topRight" (click)="edit(data.id)">
                <span class="fs-4 mx-2 tabler--edit"></span>
              </button>
            </ng-container>
          </ng-template>

        </ng-template>

        <ng-template [ngxPermissionsOnly]="[permissaoEnum.Visualizar, perfilEnum.Administracao]">
          <ng-container *ngIf="!esconderVisualizar">
            <button nz-button nzType="text" nzSize="small" nz-popover nzPopoverContent="Visualizar"
              nzPopoverPlacement="topRight" (click)="visualizarItem(data.id)">
              <span class="fs-4 mx-2 ph--magnifying-glass"></span>
            </button>
          </ng-container>
        </ng-template>
        <ng-template [ngxPermissionsOnly]="[perfilEnum.Administracao]">
          <ng-container *ngIf="nomeItem == 'Usuario'">
            <button nz-button nzType="text" nzSize="small" nz-popover nzPopoverContent="Reenviar e-mail de ativação"
              nzPopoverPlacement="topRight" (click)="reenviarEmailAtivacao(data.id)">
              <span class="fs-4 mx-2 mdi--email-fast-outline"></span>
            </button>
          </ng-container>
        </ng-template>
        <ng-template [ngxPermissionsOnly]="[permissaoEnum.Editar, perfilEnum.Administracao]">
          <ng-container *ngIf="isAtivarInativarDeletarBtn(data) && !esconderInativar">
            <ng-container *ngIf="nomeItem !== 'Usuario'">
              <button nz-button nzType="text" nzSize="small" nz-popover
                [nzPopoverContent]="textoAtivarInativarDeletarBtn(data)" nzPopoverPlacement="topRight"
                (click)="acaoAtivarInativarDeletarBtn(data)">
                <span class="fs-4 mx-2" [ngClass]="iconeAtivarInativarDeletarBtn(data)"></span>
              </button>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="mostrarExclusaoSecundarioFn()">
            <button nz-button nzType="text" nzSize="small" nz-popover nzPopoverContent="Deletar"
              nzPopoverPlacement="topRight" (click)="acaoDeletarBtn(data)">
              <span class="fs-4 mx-2 material-symbols--delete-outline"></span>
            </button>
          </ng-container>
        </ng-template>
        <ng-template [ngxPermissionsOnly]="[perfilEnum.Administracao]">
          <ng-container *ngIf="nomeItem === 'Usuario' && isAtivarInativarDeletarBtn(data) && !esconderInativar">
            <button nz-button nzType="text" nzSize="small" nz-popover
              [nzPopoverContent]="textoAtivarInativarDeletarBtn(data)" nzPopoverPlacement="topRight"
              (click)="acaoAtivarInativarDeletarBtn(data)">
              <span class="fs-4 mx-2" [ngClass]="iconeAtivarInativarDeletarBtn(data)"></span>
            </button>
          </ng-container>
        </ng-template>
      </td>
    </tr>
  </tbody>
</nz-table>
<ng-template #rangeTemplate let-range="range">
  Visualizando {{ range[1] }} de {{ dataSet?.totalElements }} resultados
</ng-template>
<ng-template #empty>
  <nz-empty [nzNotFoundContent]="'Nenhum resultado encontrado'"></nz-empty>
</ng-template>
<ng-template #footerTabela>
  <div class="d-flex justify-content-end align-items-center">
    <div class="me-4" *ngIf="dataSet?.totalElements">
      <span><strong>{{ dataSet?.totalElements }}</strong></span>
    </div>
  </div>
</ng-template>
